import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DoneIcon from '@mui/icons-material/Done';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import { useState } from 'react';

import { translationMap } from '.';

export default function Cards({ activeCard, handleCardClick }) {
  const cardIconMap = {
    Claim: PersonAddIcon,
    Schedule: EditCalendarIcon,
    'Close-Out': DoneIcon,
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '45px',
        padding: '30px 0',
        marginLeft: '20px',
      }}
    >
      {['Claim', 'Schedule', 'Close-Out'].map((option, idx) => {
        const CardIcon = cardIconMap[option];
        return (
          <Card
            key={option}
            sx={{ maxWidth: 345 }}
          >
            <CardActionArea
              onClick={(e) => handleCardClick(option, idx)}
              data-active={activeCard === idx ? '' : undefined}
              sx={{
                height: '100%',
                '&[data-active]': {
                  backgroundColor: 'action.selected',
                  '&:hover': {
                    backgroundColor: 'action.selectedHover',
                  },
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CardIcon sx={{ color: 'primary.main' }} />
                </Box>

                <Typography
                  gutterBottom
                  variant='h6'
                >
                  {option}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        );
      })}
    </Box>
  );
}
